module.exports = __webpack_public_path__ + "static/media/OurWork_Mobile.d11deef5.svg";